<script>
export default {
    name: 'video',

    props:
    {
        src: String,
    },

    render(h)
    {
        return h(
            'div',
            {
                class: ['video-wrapper']
            },
            [
                h(
                    'iframe',
                    {
                        attrs:
                        {
                            src: this.src,
                            allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
                            allowfullscreen: true,
                            frameborder: 0,
                        }
                    }
                )
            ]
        )
    }
}
</script>

<style lang="scss">
    @import "../../assets/styles/settings/settings";

    .video-wrapper {
        background-color: white;
        padding: rem(20);
        iframe {
            width: 100%;
            height: 25vw;
            @media(max-width: 1200px)
            {
                height: 33vw;
            }
            @media(max-width: 992px)
            {
                height: 40vw;
            }
        }
    }
</style>
